import { capitalize } from 'lodash-es';

export const templateToTitle = ({ name, themeId }: { name?: string | null | undefined; themeId: string }) => {
  if (name) return name;
  let title = themeId
    .replace(/^emrald_city/, 'emerald_city') // Legacy misspelling
    .replace(/_7x5$/, '')
    .replace(/_thank_you$/, '')

    // Remove "foil" for templates that don't physically have foil
    .replace(/^cinquefoil$/, 'cinque')
    .replace(/^copper_foil_blooms$/, 'copper_blooms')
    .replace(/^foil_mirrored_angles_/, 'mirrored_angles_')
    .replace(/_foil_frame$/, '_frame')

    .split('_')
    .map(capitalize)
    .join(' ')

    // This section needs to come after capitalize
    .replace(/^Lorange/, 'L’Orange')
    .replace(/^Panafrican/, 'Pan-African')
    .replace(/^Starcrossed/, 'Star-Crossed')

    .replace(/ Iv$/, ' IV') // Match 'Green Iv Foil' and 'Green Iv' but not 'Green Ivy'.
    .replace(/ Iii$/, ' III')
    .replace(/ Ii$/, ' II')
    .replace(/ Iv /, ' IV ') // See previous comment.
    .replace(/ Iii /, ' III ')
    .replace(/ Ii /, ' II ') // Example: Felicity Accommodations II Terra
    .replace(/ 2$/, ' II') // Rustic Chic 2
    .replace(/ 3$/, ' III') // Rustic Chic 3
    .replace(/ 4$/, ' IV') // Rustic Chic 4
    .replace(/ 5$/, ' V') // Rustic Chic 5
    .replace(/ 6$/, ' VI') // Rustic Chic 6
    .replace(/^Rustic Chic 5 Foil$/, 'Rustic Chic V Foil') // Digit rules above are end-anchored, so ' 5' before ' Foil' is missed
    .replace(/ A /, ' a ')
    .replace(/ And /, ' & ')
    .replace(/ In /, ' in ')
    .replace(/ Of /, ' of ')
    .replace(/Lets /, 'Let’s ')
    // Both rules match the whole space-delimited segment rather than a bare
    // substring, and neither needs a word-boundary guard: 'qr' (case
    // insensitive) never appears inside a longer word anywhere in the theme ID
    // list, only ever as its own '_qr' segment. Two rules because the infix
    // form requires a space on each side, so it can't match a trailing suffix
    // — and the trailing '_qr' is deliberately kept rather than stripped.
    .replace(/ Qr /, ' QR ')
    .replace(/ Qr$/, ' QR')
    .replace(/ Rsvp/, ' RSVP');

  // For "Gold Foil Frame Foil" and similar, remove the repeated "Foil"
  if (title.includes(' Foil ') && title.endsWith(' Foil')) {
    title = title.replace(/ Foil$/, '');
  }

  return title;
};
